import { render, staticRenderFns } from "./FooterMaskExCard.vue?vue&type=template&id=d49710d8&scoped=true&"
import script from "./FooterMaskExCard.vue?vue&type=script&lang=js&"
export * from "./FooterMaskExCard.vue?vue&type=script&lang=js&"
import style0 from "./FooterMaskExCard.vue?vue&type=style&index=0&id=d49710d8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d49710d8",
  null
  
)

export default component.exports